import React from 'react'

export default function FullTime() {
    return (
        <div>
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M49.9585 8.33337C26.9585 8.33337 8.3335 27 8.3335 50C8.3335 73 26.9585 91.6667 49.9585 91.6667C73.0002 91.6667 91.6668 73 91.6668 50C91.6668 27 73.0002 8.33337 49.9585 8.33337ZM63.7085 69.625L45.8335 51.7084V29.1667H54.1668V48.2917L69.6252 63.75L63.7085 69.625Z" fill="#BB0600" />
            </svg>

        </div>
    )
}
